<template>
  <div>
    <Header></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="padding-bottom: 30px">
      <div class="onloadBody">
        <!--申请表正文-->
        <div class="onloadDiv">
          <!--标题-->
          <div class="onloadHead">
            <p class="onloadHeadP">会员登录</p>
          </div>
          <!--选择登录方式-->
          <div class="onloadMode">
            <div class="onloadModeDiv" :class='{onloadModeDivOn:ifPassword}' @click="choicePassword">密码登录</div>
            <div class="onloadModeDiv" :class='{onloadModeDivOn:!ifPassword}' @click="choiceMessage">短信登录</div>
          </div>
          <!--** 密码登录-->
          <div class="onloadBox" v-if="ifPassword">
            <input type="text" class="form-control onloadFormText" placeholder="手机号" v-model="mobile">
            <input type="password" class="form-control onloadFormText" placeholder="密码" v-model="password" @keyup.enter="submitOnloadPass">
          </div>
          <!--** 短信登录-->
          <div class="onloadBox" v-if="!ifPassword">
            <input type="text" class="form-control onloadFormText" placeholder="手机号" v-model="mobile">
            <input type="text" class="col-7 form-control onloadFormText" placeholder="验证码" style="float: left" v-model="code" @keyup.enter="submitOnloadCode">
            <a href="#" class="applyFormA" :class="{disableA:ifdisableA}" style="margin-left: 20px" @click="getVerification">{{codeTxt}}</a>
          </div>
          <!--提交按钮-->
          <div class="onloadBox">
            <!--密码登录按钮-->
            <input type="button" class="onloadFormBtn btn" v-if="ifPassword" value="密码登录" @click="submitOnloadPass">
            <!--账号登录按钮-->
            <input type="button" class="onloadFormBtn btn" v-if="!ifPassword" value="验证登录" @click="submitOnloadCode">
            <input type="checkbox" class="checkbox" v-model="remember"><label class="applyFormLab">下次自动登录</label>
            <router-link class="onloadA" to="/apply"> 会员注册</router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemMember from '@/components/item/itemMember.vue'
import choiceApply from '@/components/apply/choiceApply.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'
import ChoiceApply from './apply/choiceApply'

export default {
  name: 'onload',
  data () {
    return {
      // token验证码
      token: this.$store.state.Token,
      // 所在页面的名称
      topName: 'onload',
      // 顶部导航栏
      ifblueme: {
        color: '#0051bd'
      },
      // 副导航栏
      ifSelection: 0,
      // 面包屑导航栏
      secondhref: '/onload',
      secondtest: '会员登录',
      // 副导航栏信息
      cate: [],
      // 会员信息
      member: [],
      // 判断密码还是短信登录
      ifPassword: true,
      // 登录提交的相关信息
      mobile: '',
      code: '',
      password: '',
      remember: false,
      // 获取验证按钮的文字
      codeTxt: '获取验证码',
      // 判断是否需要禁用二维码获取按钮
      ifdisableA: false,
      // 定时器
      timer: null
    }
  },
  components: {
    ChoiceApply,
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemMember: itemMember,
    choiceApply: choiceApply
  },
  methods: {
    // 获得验证码
    getVerification () {
      // 先验证下手机号是不是正确输入
      if (this.mobile === '') {
        this.$message.error('请输入手机号')
      } else if (this.ifErrPrompt === true) {
        this.$message.error('请输入正确的手机号')
      } else { // 验证成功
        HttpServer.post('http://api.gdics.cn/api/sign_in_code', {
          mobile: this.mobile
        }).then(res => { /* 请求成功，http状态码为200 */
          if (res.code === 200) { // 发送成功
            // 返回成功提示
            this.$message.success(res.msg + '，60秒后可重新发送')
            // 禁用发送按钮
            this.codeTxt = '59 秒后重新发送'
            this.ifdisableA = true
            let a = 58
            this.timer = setInterval(() => {
              this.codeTxt = a + ' 秒后重新发送'
              a--
              if (a < 0) {
                clearInterval(this.timer)
                this.ifdisableA = false
                this.codeTxt = '获取验证码'
              }
            }, 1000)
          } else if (res.code === 403) { // 手机号已存在等其他不满足条件的情况
            this.$message.error(res.msg)
          } else { // res.code == 500 运营商错误
            this.$message.error('运营商服务器错误')
          }
        }).catch(err => { /* 请求失败 */
          if (err.code !== 200) {
            this.$message.error('运营商错误，请稍后再试')
          }
        })
      }
    },

    // 副导航栏渲染
    viceNavigation (event) {
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        this.member = res.member
        this.cate = res.cate
      })
    },

    // 选择密码登录
    choicePassword () {
      this.ifPassword = true
    },

    // 选择短信登录
    choiceMessage () {
      this.ifPassword = false
    },

    // 密码登录
    submitOnloadPass () {
      HttpServer.post('http://api.gdics.cn/api/signin_general', {
        mobile: this.mobile, // 手机号
        password: this.password,
        remember: this.remember ? 7 : 0.5
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          // 将token和nickname和group传给localStorage
          localStorage.setItem('userToken', res.data.token)
          localStorage.setItem('userName', res.data.nickname)
          localStorage.setItem('userGroup', res.data.group)
          // 把token和nickname和group传给vuex
          this.$store.commit('add', res.data)
          // 跳转
          this.$router.push('/joinProcess')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('服务器错误')
      })
    },

    // 验证码登录
    submitOnloadCode () {
      HttpServer.post('http://api.gdics.cn/api/signin_code', {
        mobile: this.mobile, // 手机号
        code: this.code,
        remember: this.remember ? 7 : 0.5
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          // 将token和nickname和group传给localStorage
          localStorage.setItem('userToken', res.data.token)
          localStorage.setItem('userName', res.data.nickname)
          localStorage.setItem('userGroup', res.data.group)
          // 把token和nickname和group传给vuex
          this.$store.commit('add', res.data)
          // 跳转
          this.$router.push('/joinProcess')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('服务器错误')
      })
    }
  },
  mounted () {
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .onloadBody{
    width: 400px;
    margin-left: auto;
    margin-right: auto;
    text-align: right;
  }
  .onloadDiv{
    width: 100%;
    border-radius: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #ffffff;
  }
  .onloadHead{
    width: 100%;
    height: 50px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 8px;
  }
  .onloadHeadP{
    margin-top: auto;
    margin-bottom: auto;
    line-height: 50px;
    font-size: 24px;
    background-color: #0064e6;
    font-family: '微软雅黑';
  }
  .onloadMode{
    width: 80%;
    border-bottom: 1px solid #e3e3e3;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    overflow: hidden;
  }
  .onloadModeDiv{
    width: 100px;
    line-height: 50px;
    padding: 0px 10px;
    float: left;
    cursor: pointer;
    text-align: center;
  }
  .onloadModeDivOn{
    border-bottom: 2px solid #005cbf;
    color: #005cbf;
  }
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .onloadBox{
    position: relative;
    width: 80%;
    background-color: #ffffff;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    overflow: hidden;
    // border-bottom: 1px solid #e3e3e3;
  }
  .onloadBox p{
    font-size: 12px;
    color: #999999;
  }
  .onloadBox input{

  }
  .onloadSpanBox p{
    width: 100%;
    margin-bottom: 34px;
    float: right;
    color: #999999;
  }
  .onloadFormText{
    margin-bottom: 20px;
  }
  /* 提示文字的样式 */
  .onloadFormText::-webkit-input-placeholder { /* WebKit browsers */
    color: #cdcdcd;
  }
  .onloadFormText:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #cdcdcd;
  }
  .onloadFormText::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #cdcdcd;
  }
  .onloadFormText:-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #cdcdcd;
  }
  .applyFormA{
    margin: 10px;
    line-height: 36px;
  }
  .applyFormLab{
    margin-left: 10px;
    font-size: 14px;
    color: #999999;
    font-family: '微软雅黑';
  }
  .onloadA{
    float: right;
    font-size: 14px;
    color: #999999;
    font-family: '微软雅黑';
    margin: 0px 4px;
  }
  .onloadFormBtn{
    width: 100%;
    color: #ffffff;
    background-color: #0064e6;
    margin-bottom: 5px;
  }
  /* 文件选择标签 */
  .a-upload {
    padding: 4px 10px;
    height: 20px;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    color: #888;
    background: #fafafa;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;
    *display: inline;
    *zoom: 1
  }
  .a-upload  input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer
  }
  .a-upload:hover {
    color: #444;
    background: #eee;
    border-color: #ccc;
    text-decoration: none
  }
  /* 禁用获取验证码的按钮 */
  .disableA{
    pointer-events: none;
    color: #999999;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/onload.vue